<template>
  <div
    v-if="variableName && (layerNumber === 1 || compare)"
    style="display: flex; margin-left: auto"
    class="mainLegendContainer"
  >
    <div
      v-if="left"
      style="float: left; padding-left: 5px; padding-right: 5px; color: #4c4c4c"
    >
      <div v-if="!isLegendVisible" class="legendbutton">
        <b-icon icon="list-ul" v-b-toggle:[toggleName] font-scale="2"></b-icon>
      </div>
      <div v-else class="legendbutton">
        <b-icon icon="list-ul" v-b-toggle:[toggleName] font-scale="2"></b-icon>
      </div>
    </div>
    <b-collapse v-if="variableName" :id="toggleName" v-model="isLegendVisible">
      <b-card class="legendListCard">
        <div class="mt-1">
          <div>
            {{ variableName }} - {{ dateRangeStart }}-{{ dateRangeStart + 29 }}
          </div>
        </div>
        <div>
          <b-form-input
            type="range"
            v-model="opacity"
            min="0"
            max="1"
            step="0.1"
            class="mt-1 opacyityBar"
            style="width: 150px; padding: 10px"
            @change="setLayerOpacity"
          ></b-form-input></br>
         <span class="">réteg átlátszóság</span>
        </div>
        <br />
        <simplebar data-simplebar-auto-hide="false" class="legendList">
          <b-list-group>
            <b-list-group-item v-for="legend in legends" :key="legend.label + '-' + legend.url">
              <img
                class="legend"
                :src="'data:image/png;base64,' + legend.imageData"
              />
              {{ legend.label }}
            </b-list-group-item>
          </b-list-group>
        </simplebar>
      </b-card>
    </b-collapse>
    <div
      v-if="!left"
      style="
        float: right;
        padding-left: 5px;
        padding-right: 5px;
        color: #4c4c4c;
      "
    >
      <div v-if="!isLegendVisible" class="legendbutton">
        <b-icon icon="list-ul" v-b-toggle:[toggleName] font-scale="2"></b-icon>
      </div>
      <div v-else class="legendbutton">
        <b-icon icon="list-ul" v-b-toggle:[toggleName] font-scale="2"></b-icon>
      </div>
    </div>
    <span style="display: none; font-size: 2rem">{{
            compare
          }}</span>
  </div>
</template>

<script>
import axios from "axios";
import MapComponent from "./Map.vue";
import { config } from "@/config/config.js";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
export default {
  name: "LegendList",
  components: { MapComponent, simplebar },
  props: {
    legendUrl: String,
    variable: Object,
    layerNumber: Number,
    left: Boolean,
  },
  computed: {
    toggleName() {
      return "collapse-" + this.layerNumber;
    },
    compare() {
      return this.$store.state.parameterStripe.compare;
    },
    rasterFunctionName() {
      var rasterFunction;
      var rasterFunction1 =
        this.$store.state.parameterStripe.variable1_raster_function;
      var rasterFunction2 =
        this.$store.state.parameterStripe.variable2_raster_function;
      if (this.layerNumber == 1) {
        rasterFunction = rasterFunction1;
      } else {
        rasterFunction = rasterFunction2;
      }
      if (rasterFunction) {
        return rasterFunction;
      }
    },
    variableObject() {
      let variable;
      let variable1 = this.$store.state.parameterStripe.variable1;
      let variable2 = this.$store.state.parameterStripe.variable2;
      if (this.layerNumber == 1) {
        variable = variable1;
      } else {
        variable = variable2;
      }
      return variable;
    },
    variableName() {
      let name1 = this.$store.state.parameterStripe.variable1_display_name;
      let name2 = this.$store.state.parameterStripe.variable2_display_name;
      let unit1 = this.$store.state.parameterStripe.variable1_unit;
      let unit2 = this.$store.state.parameterStripe.variable2_unit;
      let processType1 = this.$store.state.parameterStripe.processType1;
      let processType2 = this.$store.state.parameterStripe.processType2;
      let name;
      let unit;
      let processType;
      if (this.layerNumber == 1) {
        name = name1;
        unit = unit1;
        processType = processType1;
      } else {
        name = name2;
        unit = unit2;
        processType = processType2;
      }
      if (processType == "p") {
        name += " (%)";
      } else if (unit) name += " (" + unit + ")";
      return name;
    },
    dateRangeStart() {
      let dateRangeStart1 = this.$store.state.parameterStripe.dateRangeStart1;
      let dateRangeStart2 = this.$store.state.parameterStripe.dateRangeStart2;
      let dateRangeStart;
      if (this.layerNumber == 1) {
        dateRangeStart = dateRangeStart1;
      } else {
        dateRangeStart = dateRangeStart2;
      }
      return dateRangeStart;
    },
  },
  watch: {
    rasterFunctionName: function () {
      this.getLegends();
    },
  },
  data: function () {
    return {
      legends: [],
      opacity: config.defaultOpacity,
      //rasterFunctionName: "",
      isLegendVisible: true,
    };
  },
  mounted() {
    //this.setLayerOpacity();
    //this.getLegends();
  },
  methods: {
    getLegends() {
      if (!this.rasterFunctionName) return;

      let url =
        config.imageService.teszt +
        "/legend?bandIds=&renderingRule=%7B%22rasterFunction%22%3A%22" +
        this.rasterFunctionName +
        "%22%7D&f=pjson";
      axios
        .get(
          //this.legendUrl
          url
          /*"https://localhost:6443/arcgis/rest/services/ImageService/mosaic_dataset/ImageServer/legend?bandIds=&renderingRule=%7B%22rasterFunction%22%3A%22test%22%7D&f=pjson"*/
        )
        .then((result) => {
          console.log(result);
          if (
            result.data &&
            result.data.layers.length > 0 &&
            result.data.layers[0].legend
          )
            this.legends = result.data.layers[0].legend;
        });
    },
    setLayerOpacity() {
      this.$root.$refs.MapRef.setLayerOpacity(this.opacity, this.layerNumber);
    },
  },
};
</script>

<style scoped>
.legendbutton {
  border: 1px solid #57585a;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  width: 32px;
  height: 32px;
  background-color: white;
  cursor: pointer;
  padding: 5px;
}

.legendList {
  max-height: calc(100vh - 465px);
  /*overflow-y: auto;*/
}
>>>.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  background-color: #2e9d9a !important;
}

.list-group-item {
  border-style: none;
}
svg:focus {
  outline: none !important;
}
>>> .legend {
  width: 10px;
}
>>> .list-group-item {
  padding: 0 !important;
  padding-left: 5px;
  padding-bottom: 0px;
  padding-top: 0px;
  text-align: left;
}
.card {
  background-color: white;
}
.opacyityBar {
  position: relative;
  top: 5px;
}
.legendListCard{
  width: 210px;
}
.opacyityBar::-webkit-slider-thumb {
  background: #2e9d9a!important;
}

.opacyityBar::-moz-range-thumb {
  background: #2e9d9a!important;
}

.opacyityBar::-ms-thumb {
  background: #2e9d9a!important;
}
</style>
